import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux';
import App from './App'
import configureStore from './store';
import buildConfig from './util/buildConfig';

const appLayerWrapper = document.querySelector('[data-app-layer="main"]');
const config = buildConfig(appLayerWrapper.dataset);
export const store = configureStore(config);

const initAppLayer = () => {
  const appLayerWrapper = document.querySelector('[data-app-layer="main"]');
  const config = buildConfig(appLayerWrapper.dataset);
  const store = configureStore(config);

  // Render some shit
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    appLayerWrapper
  );
}


//
// Turbo links instantiation
// --------------------------
if (window['theme']['turbolinksEnabled']) {
  window.addEventListener('turbolinks:load', () => {
    console.info('TURBOLINKS - engaging app layer')
    return initAppLayer()
  })

  window.addEventListener('blubolt:load', () => {
    if (window.blubolt && window.blubolt.turboLinksActive) {
      return initAppLayer()
    }
    return;
  })
}

//
// No Turbolinks? No problem
// ---------------------------
else {
  initAppLayer();
}